import script from './SdsAvatar.vue_rollup-plugin-vue=script.js';
import normalizeComponent from '../../node_modules/vue-runtime-helpers/dist/normalize-component.mjs.js';
import createInjector from '../../node_modules/vue-runtime-helpers/dist/inject-style/browser.mjs.js';

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('SdsSkeletonEffect',{staticClass:"sds-avatar",class:[
        ("sds-avatar--" + _vm.size),
        ("sds-avatar--" + _vm.variant) ],attrs:{"isLoading":_vm.isLoading}},[_c('div',{staticClass:"sds-avatar--content",style:({ backgroundImage: _vm.image && ("url(" + _vm.image + ")") })},[(_vm.text && !_vm.image)?_c('span',[_vm._v(_vm._s(_vm.text))]):_vm._e(),_vm._v(" "),(!_vm.text && !_vm.image)?_c('SdsIcon',{attrs:{"iconName":"human-user","size":_vm.fallbackIconSize}}):_vm._e()],1),_vm._v(" "),(_vm.hasNotification)?_c('div',{staticClass:"sds-avatar--indicator"}):_vm._e(),_vm._v(" "),(_vm.iconName)?_c('SdsIcon',{staticClass:"sds-avatar--status",attrs:{"iconName":_vm.iconName,"size":_vm.statusIconSize,"isThemed":_vm.isIconThemed}}):_vm._e()],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-026197b5_0", { source: ".sds-avatar[data-v-026197b5]{position:relative;border-radius:var(--radius-full);color:var(--system-text-on-color-primary);flex-shrink:0}.sds-avatar--image .sds-avatar--content[data-v-026197b5]{background-position:center;background-size:cover}.sds-avatar--text-only[data-v-026197b5]{text-transform:uppercase}.sds-avatar--text-only .sds-avatar--content[data-v-026197b5]{display:flex;align-items:center;justify-content:center}.sds-avatar--content[data-v-026197b5]{width:inherit;height:inherit;border-radius:inherit}.sds-avatar--xs[data-v-026197b5]{width:20px;height:20px}.sds-avatar--sm[data-v-026197b5]{width:24px;height:24px}.sds-avatar--md[data-v-026197b5]{width:32px;height:32px}.sds-avatar--lg[data-v-026197b5]{width:40px;height:40px}.sds-avatar--xl[data-v-026197b5]{width:56px;height:56px}.sds-avatar--xxl[data-v-026197b5]{width:96px;height:96px}.sds-avatar--xs[data-v-026197b5]{font-size:9px}.sds-avatar--sm[data-v-026197b5]{font-size:10px}.sds-avatar--md[data-v-026197b5]{font-size:13px}.sds-avatar--lg[data-v-026197b5]{font-size:16px}.sds-avatar--xl[data-v-026197b5]{font-size:20px}.sds-avatar--xxl[data-v-026197b5]{font-size:24px}.sds-avatar--indicator[data-v-026197b5]{position:absolute;top:-2px;right:-2px;height:4px;width:4px;background-color:var(--component-top-nav-graphics-notification-indicator);border-radius:var(--radius-full)}.sds-avatar--xxl .sds-avatar--indicator[data-v-026197b5]{width:12px;height:12px;top:0;right:0}.sds-avatar--status[data-v-026197b5]{position:absolute;right:-8px;bottom:-8px}.sds-avatar--xxl .sds-avatar--status[data-v-026197b5]{right:0;bottom:0}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-026197b5";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/normalizeComponent(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    createInjector,
    undefined,
    undefined
  );

export default __vue_component__;
